import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import { Breed } from '../../../../structures/models/breed';
import OptionalListItem from './util/OptionalListItem';

interface BreedAtAGlanceAdProps {
  breed: Breed;
  breedNamePlural: string;
  listingType: string;
}

const BreedAtAGlanceAd: React.FC<BreedAtAGlanceAdProps> = (data): ReactElement => {
  const {
    breed,
    breedNamePlural = '',
    listingType = '',
  } = data;

  return (
    <section className="breed-at-a-glance">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="mx-auto glance-gead mt-1">
              {`${breedNamePlural || breed.name} at a Glance`}
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col col-12">
            <ul className="mx-auto glance-gead-list font-awesome-bullets">
              <OptionalListItem
                className="text-capitalize"
                label="Size"
                data={breed?.size_description}
              />
              <OptionalListItem
                className="text-capitalize"
                label="Lifespan"
                data={breed?.lifespan}
              />
              <OptionalListItem
                className="text-capitalize"
                label="Energy Level"
                data={breed?.energy_level}
              />
              <OptionalListItem
                className="text-capitalize"
                label="Coat"
                data={breed?.coat_description}
              />
              <OptionalListItem
                className="text-capitalize"
                label="Shedding"
                data={breed?.shedding}
              />
              <OptionalListItem
                className="text-capitalize"
                label="Hypoallergenic"
                data={breed?.hypoallergenic ? 'Yes' : 'No'}
              />
              <OptionalListItem
                className="text-capitalize"
                label="Dog Group"
                data={breed?.group?.name}
              />
              <OptionalListItem
                className="text-capitalize"
                label="Common Nicknames"
                data={breed?.alternative_breed_names ? breed?.alternative_breed_names.join(', ') : ''}
              />
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <a
              href={listingType === 'stud' ? `${breed.route}/stud` : breed.route}
              className="mt-4 basic-family text-uppercase btn btn-lg btn-outline-beige"
            >
              {`Learn More About ${breedNamePlural || breed.name}`}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BreedAtAGlanceAd;

if (document.querySelectorAll('.breed-glance.ad').length > 0) {
  document.querySelectorAll('.breed-glance.ad').forEach((element) => {
    const breed = JSON.parse(element.getAttribute('data-breeds') ?? '');
    const breedNamePlural = element.getAttribute('data-breed-name-plural') || '';
    const listingType = element.getAttribute('data-listing-type') || '';

    ReactDOM.render(
      <BreedAtAGlanceAd
        breed={breed}
        breedNamePlural={breedNamePlural}
        listingType={listingType}
      />,
      element,
    );
  });
}
